import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="pwa-install"
export default class extends Controller {
  static targets = ["installBanner", "installButton"]

  connect() {
    this.deferredPrompt = null
    this.setupInstallPrompt()
    this.checkIfInstalled()
  }

  setupInstallPrompt() {
    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault()
      // Stash the event so it can be triggered later
      this.deferredPrompt = e
      // Show install banner if available
      if (this.hasInstallBannerTarget) {
        this.showInstallBanner()
      }
    })

    window.addEventListener('appinstalled', () => {
      console.log('PWA was installed')
      this.hideInstallBanner()
      // Clear the deferredPrompt
      this.deferredPrompt = null
      // Track installation status
      localStorage.setItem('pwa-installed', 'true')
    })
  }

  checkIfInstalled() {
    // Check if app is already installed
    if (window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone === true ||
        localStorage.getItem('pwa-installed') === 'true') {
      this.hideInstallBanner()
    }
  }

  install() {
    if (!this.deferredPrompt) {
      return
    }

    // Show the prompt
    this.deferredPrompt.prompt()

    // Wait for the user to respond to the prompt
    this.deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the install prompt')
        localStorage.setItem('pwa-install-dismissed', 'false')
      } else {
        console.log('User dismissed the install prompt')
        localStorage.setItem('pwa-install-dismissed', 'true')
      }
      this.deferredPrompt = null
      this.hideInstallBanner()
    })
  }

  dismiss() {
    this.hideInstallBanner()
    localStorage.setItem('pwa-install-dismissed', 'true')
  }

  showInstallBanner() {
    // Don't show if user has dismissed before
    if (localStorage.getItem('pwa-install-dismissed') === 'true') {
      return
    }

    if (this.hasInstallBannerTarget) {
      this.installBannerTarget.classList.remove('hidden')
    }
  }

  hideInstallBanner() {
    if (this.hasInstallBannerTarget) {
      this.installBannerTarget.classList.add('hidden')
    }
  }
}